const Roles = {
  Admin: 'admin',
  FacultySecretary: 'faculty-secretary',
};

export default Roles;
